import * as Yup from 'yup';

export const FIELDS_NAME = {
  EMAIL: 'email',
  ALIAS: 'alias',
  ACTIVE_QR: 'active_qr',
  ACTIVE_CASHOUT: 'active_cashout',
};

export const initialValues = {
  [FIELDS_NAME.EMAIL]: '',
  [FIELDS_NAME.ALIAS]: '',
  [FIELDS_NAME.ACTIVE_QR]: true,
  [FIELDS_NAME.ACTIVE_CASHOUT]: true,
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.EMAIL]: Yup.string()
    .email('Email inválido')
    .required('Campo requerido'),
  [FIELDS_NAME.ALIAS]: Yup.string()
    .required('Campo requerido')
    .test('is-valid-alias', 'Formato invalido', (value) => {
      if (!value) return false;

      const aliasRegex = /^[A-Za-z_]{6,20}$/;

      return aliasRegex.test(value);
    }),
  [FIELDS_NAME.ACTIVE_QR]: Yup.boolean(),
  [FIELDS_NAME.ACTIVE_CASHOUT]: Yup.boolean(),
});
